import { Tag } from "components/base/base";
import { useModals } from "ModalProvider";
import { createContext, useContext, useEffect, useState } from "react";
import { AmazonContext } from ".";
import AcknowledgedOrder from "./AcknowledgedOrder";
import NewOrderView from "./NewOrderView";
import AckOrdersView from "./orders/AckOrdersView";
import RegionRows from "./orders/RegionRows";

const AWS_REGIONS = ["GB", "DE", "IT", "ES", "FR"];
const STATE_OPTIONS = ["New", "Acknowledged", "Closed"];

export const AmzContext = createContext({});

const OrdersPage = () => {
  const { stockCategories } = useContext(AmazonContext);
  const [regions, setRegions] = useState(
    localStorage.getItem("amazon:regions")
      ? JSON.parse(localStorage.getItem("amazon:regions"))
      : AWS_REGIONS,
  );
  const [orderState, setOrderState] = useState(
    localStorage.getItem("amazon:orderState") || STATE_OPTIONS[0],
  );

  useEffect(() => {
    if (regions)
      localStorage.setItem("amazon:regions", JSON.stringify(regions));
    if (orderState) localStorage.setItem("amazon:orderState", orderState);
  }, [regions, orderState]);

  const acknowledgementModal = useModals();
  const ackOrdersModal = useModals();

  function ackOrders({ region, orders }) {
    ackOrdersModal.present({
      title: "Ack Orders",
      subtitle: `Acknowledge ${region} orders(${orders.length})`,
      fullscreen: true,
      isBeingPresented: true,
      children: <AckOrdersView region={region} orders={orders} />,
    });
  }

  function selectOrder({ order, region }) {
    acknowledgementModal.present({
      title: `[${region}] ${order.purchaseOrderNumber}`,
      maxWidth: "max-w-full",
      children:
        order.purchaseOrderState === "New" ? (
          <NewOrderView
            regionCode={region}
            order={order}
            hide={acknowledgementModal.hide}
            stockCategories={stockCategories}
          />
        ) : (
          <AcknowledgedOrder regionCode={region} order={order} />
        ),
    });
  }

  return (
    <AmzContext.Provider value={{ ackOrders, orderState }}>
      <div className="p-6">
        <div className="flex space-x-16">
          <div className="flex mb-6 space-x-4">
            {AWS_REGIONS.map((i, index) => (
              <Tag
                title={i}
                key={index}
                selected={regions.includes(i)}
                onClick={() =>
                  setRegions((prev) =>
                    prev.includes(i)
                      ? prev.filter((j) => j !== i)
                      : [...prev, i],
                  )
                }
              />
            ))}
          </div>

          <div className="flex mb-6 space-x-4">
            {STATE_OPTIONS.map((i, index) => (
              <Tag
                title={i}
                key={index}
                selected={orderState === i}
                onClick={() => setOrderState(i)}
              />
            ))}
          </div>
        </div>

        <label className="block mb-4 text-orange-600 text-xs">
          Contact Charlie if there is any issue. Please double check the order
          status in Amazon Vendor Center.
        </label>

        <table className="bg-white dark:bg-gray-800 rounded overflow-auto">
          <thead>
            <tr className="text-left border-b dark:border-gray-700">
              <th className="py-3 px-6">Region</th>
              <th className="py-3 ">Purchase Order Number</th>
              <th className="py-3 text-center">Date</th>
              <th className="py-3 text-center">Window Start</th>
              <th className="py-3 text-center">Window End</th>
              <th className="py-3 text-center">Biling to Party</th>
              <th className="py-3 text-center">Ship to Party</th>
              <th className="py-3 text-center">Status</th>
              <th className="py-3 text-center">Odoo</th>
            </tr>
          </thead>
          <tbody>
            {regions.map((region, index) => (
              <RegionRows
                selectOrder={(order) => selectOrder({ region, order })}
                region={region}
                orderState={orderState}
                key={index}
              />
            ))}
          </tbody>
        </table>
      </div>
    </AmzContext.Provider>
  );
};

export default OrdersPage;
